// Define the possible strength levels for a password
type strengthLevels = "Weak" | "Medium" | "Strong";

// Regular expressions to detect specific character types
const upperRegex = /[A-Z]/;      // Checks for uppercase letters
const lowerRegex = /[a-z]/;      // Checks for lowercase letters
const specialRegex = /[!@#$%&*^]/; // Checks for common special characters
const digitRegex = /[\d]/;       // Checks for digits (0–9)

// Main function that evaluates password strength
export function testPasswordStrength(password: string): strengthLevels {
  // Boolean checks for various password features
  const lengthScore = password.length >= 8;          // Must be at least 8 characters long
  const hasUpper = upperRegex.test(password);        // Contains at least one uppercase letter
  const hasLower = lowerRegex.test(password);        // Contains at least one lowercase letter
  const hasDigit = digitRegex.test(password);        // Contains at least one number
  const hasSpecial = specialRegex.test(password);    // Contains at least one special character
  const hasPassword = password.toLowerCase().includes("password"); // Contains the word "password"

  // Calculate the "score" based on how many of the above conditions are true
  // Each true value counts as one point
  let score = [lengthScore, hasUpper, hasLower, hasDigit, hasSpecial].filter(Boolean).length;

  
  if (hasPassword || password.length < 8 || password.includes(" ")) {
    score = 0;
  } 

  // Return strength level based on score value
  if (score < 3) {
    return "Weak"; 
  } 
  else if (score > 2 && score < 5) {
    return "Medium"; 
  } 
  else {
    return "Strong"; 
  }
}
